import styled from 'styled-components';

export const TrialWindowContainer = styled.div`
  background: #F4F4F4;
  box-shadow: 0px 7px 15px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 3;
  padding: 16px 24px;
  font-size: 12px;
`;

export const DaysRemaining = styled.div`
  color: ${({ theme }) => theme.colors.palette[7]};
  display: inline-block;
  margin-right: 5px;
`;

export const TrialText = styled.div`
  color: ${({ theme }) => theme.colors.palette[4]};
  display: inline-block;
`;
